
// 获取用户是否有当前权限。user指用户获取到的权限，permission指当前功能对应的权限名称
export function hasPermissions (user, permission) {
  return user.includes(permission)
}
